
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.971 40.095L48.312 18.58a.996.996 0 00-.19-.368s0-.01-.01-.02c-.02-.03-.06-.04-.08-.06-.07-.07-.14-.13-.23-.179-.05-.02-.09-.03-.14-.05a1.02 1.02 0 00-.25-.06c-.02 0-.04-.01-.06-.01H10.088c-.48 0-.89.34-.98.807l-4.08 21.514a.97.97 0 00.21.817c.19.229.47.358.77.358h37.245c.48 0 .89-.338.98-.806l3.26-17.174L51.7 39.338h-2.6a1 1 0 00-.999.996 1 1 0 001 .995h3.9c.31 0 .6-.14.79-.388a.978.978 0 00.18-.846zm-11.548-.747H7.218l3.71-19.523h35.214l-3.72 19.523z"}}),_c('path',{attrs:{"d":"M24.896 31.393l5.289 3.425a1.002 1.002 0 001.38-.289.992.992 0 00-.29-1.373l-4.74-3.077 1.13-6.85a.998.998 0 00-1.97-.329l-1.23 7.498c-.08.388.1.776.43.995z"}})])
          )
        }
      }
    